// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1KY1i","buttons":"RemoveExpirationActionButtons_buttons__ZWbcJ"};